import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
var _div;
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { clsx } from 'clsx';
import Triangle from "./components/Triangle";
import { adjustPosition } from "./helpers/getPosition";
import { useOnScreenVariation } from "./useOnScreenVariation";

/**
 * @deprecated This tooltip wrapper is deprecated. Please refer to the Tooltip in "@compass.ui/v2"
 */
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var TooltipWrapper = function TooltipWrapper(_ref) {
  var containerClassName = _ref.containerClassName,
    contentClassName = _ref.contentClassName,
    _ref$position = _ref.position,
    position = _ref$position === void 0 ? 'top' : _ref$position,
    children = _ref.children,
    message = _ref.message,
    offset = _ref.offset,
    sectionClassName = _ref.sectionClassName;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    show = _useState2[0],
    setShow = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    willHide = _useState4[0],
    setWillHide = _useState4[1];
  var _useState5 = useState(position),
    _useState6 = _slicedToArray(_useState5, 2),
    currentPosition = _useState6[0],
    setCurrentPosition = _useState6[1];
  var contentRef = useRef(null);
  var containerRef = useRef(null);
  var setContentPosition = useCallback(function (_ref2) {
    var newPosition = _ref2.newPosition,
      top = _ref2.top,
      bottom = _ref2.bottom,
      left = _ref2.left,
      right = _ref2.right;
    var tooltipContent = contentRef.current;
    if (!tooltipContent) return;
    setCurrentPosition(newPosition);
    tooltipContent.style.top = top !== null && top !== void 0 ? top : '';
    tooltipContent.style.bottom = bottom !== null && bottom !== void 0 ? bottom : '';
    tooltipContent.style.left = left !== null && left !== void 0 ? left : '';
    tooltipContent.style.right = right !== null && right !== void 0 ? right : '';
  }, [contentRef]);
  var adjustTooltipPosition = useCallback(function () {
    var content = contentRef.current;
    var container = containerRef.current;
    if (!content || !container) return;
    var contentPosition = adjustPosition({
      position: position,
      content: content,
      container: container,
      offset: offset
    });
    setContentPosition(contentPosition);
  }, [contentRef, containerRef, position, offset, setContentPosition]);
  useOnScreenVariation(adjustTooltipPosition, {
    runAtStart: true,
    message: message
  });
  var handleMouseEnter = function handleMouseEnter() {
    setShow(true);
    setWillHide(false);
  };
  var handleMouseLeave = function handleMouseLeave() {
    setWillHide(true);
  };
  useEffect(function () {
    if (!willHide) return;
    var debounceHide = setTimeout(function () {
      setShow(false);
      setWillHide(false);
    }, 300);
    return function () {
      return clearTimeout(debounceHide);
    };
  }, [willHide]);
  return /*#__PURE__*/_jsxs("span", {
    ref: containerRef,
    className: clsx(containerClassName, 'tw-relative'),
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleMouseLeave,
    children: [children, /*#__PURE__*/_jsxs("div", {
      className: clsx('tw-pointer-events-none tw-absolute tw-flex tw-w-full tw-h-full tw-items-center tw-justify-center -tw-top-0.2 tw-left-0 tw-transition-opacity tw-duration-300', contentClassName, show && message ? 'tw-visible tw-opacity-100' : 'tw-invisible tw-opacity-0'),
      children: [/*#__PURE__*/_jsx(Triangle, {
        tooltipPosition: currentPosition,
        offset: offset
      }), /*#__PURE__*/_jsxs("div", {
        ref: contentRef,
        className: clsx('tw-font-body5 tw-flex tw-absolute tw-bg-neutral-dark-700 tw-text-neutral-light-100 dark:tw-bg-neutral-light-200 dark:tw-text-neutral-light-800 tw-p-0.8 tw-rounded-0.8 tw-z-dialog tw-max-w-lg tw-w-max', sectionClassName),
        children: [message, _div || (_div = /*#__PURE__*/_jsx("div", {}))]
      })]
    })]
  });
};
export default TooltipWrapper;